import React, { Component } from 'react';
import Spinner from '../common/Spinner/Spinner';
import DataPolicies from './DataPolicies';
import config from '../../config';


export class DataPoliciesContainer extends Component {
  state = {
    content: ''
  }

  async componentDidMount() {
    const res = await fetch(`${config.fetchURL}/pages?slug=adatkezelesi-iranyelvek`);
    const data = await res.json();

    this.setState({ content: data[0].content.rendered });
  }

  render() {
    const { content } = this.state;

    if (content.length > 0) {
      return <DataPolicies content={content} />;
    } else {
      return <Spinner style={{ marginTop: '200px', marginBottom: '200px' }} />;
    }
  }
}


export default DataPoliciesContainer;



// WEBPACK FOOTER //
// ./src/components/DataPolicies/DataPoliciesContainer.js